
























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getWebofficeById, resetWebofficeKey, updateWebofficeInfo, updateWebofficeCallback } from '@/apps/open/services/weboffice'
import { IWeboffice } from '@/apps/open/types/weboffice'
import { WEBOFFICE_DOC_URL } from '@/apps/open/constants'
import AdminLayout from '@/apps/open/layout/AdminLayout.vue'
import ApiUsage from './ApiUsage.vue'
import ApiTool from './ApiTool.vue'
import InputFormDialogBody from '@/apps/open/components/DialogBodys/InputForm.vue'
import EmailAdminDialogBody from '@/apps/open/components/DialogBodys/EmailAdmin.vue'

@Component({
  components: {
    AdminLayout,
    ApiUsage,
    ApiTool
  }
})
export default class Info extends Vue {
  breadcrumbs: any = [{
    name: '金山文档在线编辑服务',
    routeName: 'weboffice-list'
  }]

  tabs = [{
    name: '开发信息',
    key: 'info',
    showAction: true
  }, {
    name: '数据统计',
    key: 'usage'
  }, {
    name: '接口调试工具',
    key: 'apitool'
  }]

  activeTab = this.tabs[0]

  app_id = ''
  model = {} as IWeboffice
  hideAppKey = true

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  @Watch('model')
  onModelChange (newValue: any, oldValue: any) {
    if (newValue !== oldValue) {
      this.breadcrumbs.push({
        name: newValue.app_name
      })
    }
  }

  async created () {
    this.app_id = this.$route.params['id']
    try {
      const params = {
        developer_id: this.curEnterprise.developer_id
      }
      const resp = await getWebofficeById(this.app_id, params)
      this.model = resp.data
    } catch (error) {
      this.$message.error(error.message)
    }
  }

  jumpDevDoc () {
    window.open(WEBOFFICE_DOC_URL)
  }

  showEmailAdminDialog (function_id: number) {
    this.$dialog.show({
      title: '邮件管理',
      body: EmailAdminDialogBody,
      bodyProps: {
        function_id,
        is_wwo: true
      }
    })
  }

  showCallbackUrlDialog () {
    this.$dialog.show({
      title: '修改数据回调地址',
      body: InputFormDialogBody,
      bodyProps: {
        value: this.model.gateway,
        rules: [
          { required: true, message: '请输入回调地址', trigger: ['blur', 'change'] },
          { type: 'url', message: '地址格式不正确' }
        ],
        placeholder: '如 https://xxx.xxx.com/xxx',
        submit: this.setCallbackUrl
      },
      buttons: [
        { text: '取消' },
        { text: '保存', type: 'primary', event: 'onOk' }
      ]
    })
  }

  async setCallbackUrl (callbackUrl: string) {
    this.$dialog.show({
      title: '修改数据回调地址',
      body: `
        <div style="line-hehgit: 24px">
          <div>确定修改回调地址吗？</div>
          <div>修改后新地址将会立即生效</div>
        </div>
      `,
      buttons: [
        { text: '取消' },
        { text: '修改',
          type: 'primary',
          fn: async () => {
            try {
              const urlParams = { developer_id: this.curEnterprise.developer_id }
              const resp = await updateWebofficeCallback(this.model.app_id, { gateway: callbackUrl }, urlParams)
              const data = resp.data as any
              this.model.gateway = data.gateway
            } catch (error) {
              this.$message.error(error.message)
            }
            this.$dialog.close()
          }
        }
      ]
    })
  }

  switchAppKey () {
    this.hideAppKey = !this.hideAppKey
  }

  showResetAppKeyDialog () {
    const dialogBody = `
      <div class="desc">
        <div>确定重置APPKEY吗？</div>
        <div>重置后旧APPKEY会立即失效</div>
      </div>
    `
    this.$dialog.show({
      title: '重置APPKEY',
      body: dialogBody,
      buttons: [
        { text: '取消' },
        { text: '重置', type: 'primary', fn: this.resetAppKey }
      ]
    })
  }

  async resetAppKey () {
    try {
      const params = {
        developer_id: this.curEnterprise.developer_id
      }
      const resp = await resetWebofficeKey(this.app_id, params)
      const data = resp.data
      this.model.app_key = data.app_key
      this.$message.success('重置APPKEY成功')
    } catch (error) {
      this.$message.error(error.message)
    }
    this.$dialog.close()
  }

  showUpdateNameDialog () {
    this.$dialog.show({
      title: '修改应用名',
      body: InputFormDialogBody,
      bodyProps: {
        value: this.model.app_name,
        rules: [{ required: true, message: '请输入应用名', trigger: ['blur', 'change'] }],
        inputProps: { maxlength: '20' },
        submit: this.updateName
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  async updateName (appName: string) {
    try {
      const resp = await updateWebofficeInfo(this.app_id, { app_name: appName }, { developer_id: this.curEnterprise.developer_id })
      const data = resp.data
      this.model.app_name = data.app_name
      this.$message.success('应用名修改成功')
    } catch (error) {
      this.$message.error(error.message)
    }
    this.$dialog.close()
  }
}
